import api from 'config/axiosConfig';

interface AuthLogoutProps {
    redirectToHome?: boolean;
}

export const handleLogout = async ({ redirectToHome = false }: AuthLogoutProps): Promise<void> => {
    try {
        const response = await api.post('/auth/logout');
        if (response.status === 200) {
            if (redirectToHome) {
                window.location.href = '/';
            } else {
                window.location.reload();
            }
        }
    } catch (error) {
        console.error('Error logging out:', error);
        if (redirectToHome) {
            window.location.href = '/';
        } else {
            window.location.reload();
        }
    }
};